import React from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import TableInc from '../../../../../shared-ui/TableInc';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import { getPartner, hasAuthourity } from '../../../../../lib/access.es6';
import Tooltip from '@mui/material/Tooltip';
import { ClaimTypeEnum } from '../../../lib/enum';
import { formatDateLocale } from '../../../../../lib/utils.es6';

const HospitalExpenses = (props) => {
  const classes = useStyle();
  const currencyCode = getPartner().country.currency_code
  const EDITABLE_BENEFIT_TYPES = ['Funeral Services', 'Funeral Service'];

  const tempArr = props.claimExpense.benefit_usages.map(benefit => {
    const isEditable =
      benefit.is_editable !== false &&
      EDITABLE_BENEFIT_TYPES.indexOf(benefit.benefit_type) !== -1;

    return {
      ...benefit,
      isEditable,
      amount_in_cents: benefit.benefit_amount_in_cents,
      invoice_amount_in_cents:  benefit.invoice_amount_in_cents ? `${currencyCode} ${(benefit.invoice_amount_in_cents).toLocaleString()}` : "N/A" ,
      benefit_amount_in_cents: benefit.benefit_amount_in_cents
        ? `${currencyCode}  ${(benefit.benefit_amount_in_cents / 100).toLocaleString()}`
        : (isEditable ? "Pending – click Edit to capture" : "N/A"),
      benefit_type: benefit.benefit_type ? benefit.benefit_type : "N/A",
      benefit_usage_count: benefit.benefit_usage_count ? benefit.benefit_usage_count : "N/A",
      invoice_number: props.type === ClaimTypeEnum.death ? benefit.external_unique_identifier : benefit.invoice_number ? benefit.invoice_number : "N/A",
      expense_code: (benefit.additional_details && benefit.additional_details.expense_code)
        ? benefit.additional_details.expense_code
        : (benefit.expense_code ? benefit.expense_code : "N/A"),
      created_at: benefit.created_at ? formatDateLocale(benefit.created_at) : "N/A"
    }

  })
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}  >
          <Grid container spacing={2} className={classes.claimdocswrapper}>
            <Grid item xs={12} sm={12} md={12}>
              <TableInc
                columns={[
                  { title: 'Invoice Number', field: 'invoice_number' },
                  { title: 'Expense Code', field: 'expense_code' },
                  { title: 'Expense Type & Description', field: 'benefit_type' },
                  { title: 'Amount Payable', field: 'benefit_amount_in_cents' },
                  { title: 'Created At', field: 'created_at' },
                  {
                    title: 'Action', field: 'action', render: rowData => {
                      return <div className={classes.actionbtn}>
                        {rowData.isEditable && (
                          <Tooltip title="Edit Invoice">
                            <span style={{ cursor: "pointer", display: hasAuthourity('UPDATE_CLAIM') ? 'inline' : 'none' }} onClick={() => { props.setClaimExpenseToEdit(rowData); props.toggleEditClaimExpenseDialog(); }} > <EditIcon sx={{ color: "#032a37" }} /></span>
                          </Tooltip>
                        )}
                        <Tooltip title="Delete Claim Expense">
                          <span style={{ cursor: "pointer", display: hasAuthourity('UPDATE_CLAIM') ? 'inline' : 'none' }} onClick={() => props.setClaimExpenseToDelete(rowData)} > <DeleteIcon sx={{ color: "#8F191C" }} /></span>
                        </Tooltip>
                        <Tooltip title="Download Claim Summary">
                          <span style={{ cursor: "pointer", display: hasAuthourity('UPDATE_CLAIM') ? 'inline' : 'none' }} onClick={() => props.downloadClaimSummary()} > <DownloadIcon sx={{ color: "green" }} /></span>
                        </Tooltip>
                      </div>
                    }
                  },
                ]}
                data={tempArr}
                options={{
                  // Fixed, not derived from tempArr.length: material-table only reads
                  // options.pageSize at its OWN initial mount and never reacts to it
                  // changing afterward. Invoices arrive incrementally from the
                  // auto-create merges, so if this table first rendered with only 1
                  // row, a length-derived pageSize would freeze at 1 forever — showing
                  // "1 rows" / "1-1 of 2" even once every invoice has landed. A fixed
                  // value sidesteps that entirely (and is still never 0).
                  pageSize: 5,
                  showTitle: false,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>



          <div className={classes.totalExpense}>
            <p><strong>Total Claim Expense</strong>: {currencyCode + " " + (props.claimExpense.benefit_usages.reduce((psum, expense) => psum + expense.benefit_amount_in_cents, 0) / 100).toLocaleString()}  </p>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default HospitalExpenses